import { createFileRoute, Outlet } from '@tanstack/react-router'

import { MarketplaceCartProvider } from '@/providers/MarketplaceCartProvider';
import { useLanguage } from '@/providers/LanguageProvider';

export const Route = createFileRoute('/marketplace/$slug')({
      component: Marketplace
})

function Marketplace() {
    const { currentLanguage } = useLanguage();
    
    return (
        <MarketplaceCartProvider slug={Route.useParams().slug} language={currentLanguage}>
            <Outlet />
        </MarketplaceCartProvider>
    );
}
